export const webview = {
  webviewContent: 'This is external URL and it will be opened in a new window. Open?',
  webviewButtonOpenTitle: 'Open',
  webviewButtonCopyTitle: 'Copy URL',
  webviewButtonOpenAgainTitle: 'Open again',
  notifications: {
    urlCopied: 'URL copied!'
  }
}
